import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../protected-route';
import RiderPaymentsPage from '../../../../pages/partner/rider-payments';
import CompaniesPaymentsPage from '../../../../pages/partner/companies-payments';

const PartnerHomePage = lazy(() => import('../../../../pages/partner/home'));
const PartnerAccountPage = lazy(() =>
	import('../../../../pages/partner/account')
);
const PartnerCompaniesPage = lazy(() =>
	import('../../../../pages/partner/companies')
);
const PartnerCompaniesFormPage = lazy(() =>
	import('../../../../pages/partner/companies-form')
);
const PartnerPaymentsPage = lazy(() =>
	import('../../../../pages/partner/payments')
);
const PartnerOrdersPage = lazy(() =>
	import('../../../../pages/partner/orders')
);
const PartnerZonesPage = lazy(() => import('../../../../pages/partner/zones'));
const PartnerReportsPage = lazy(() =>
	import('../../../../pages/partner/reports')
);
const WhatsappConfigPage = lazy(() =>
	import('../../../../pages/partner/whatsapp')
);
// const DeliveryCompany = lazy(() =>
// 	import('../../../../pages/partner/delivered-company')
// );
const PartnerExpensesAndBasesPage = lazy(() =>
	import('../../../../pages/partner/expenses-bases')
);
const RequestsNewCollaboratorsPage = lazy(() =>
	import('../../../../pages/partner/requests')
);
const SchedulesPage = lazy(() =>
	import('../../../../pages/business/schedules')
);
const PromoPage = lazy(() => import('../../../../pages/business/promo'));
const ProductPage = lazy(() => import('../../../../pages/business/product'));
const ProductsPage = lazy(() => import('../../../../pages/business/products'));
const BusinessPage = lazy(() => import('../../../../pages/business/business'));
const UploadProductsPage = lazy(() =>
	import('../../../../pages/business/upload-products')
);
const UploadAdditionsPage = lazy(() =>
	import('../../../../pages/business/upload-additions')
);
const DeliveryRidersPage = lazy(() =>
	import('../../../../pages/delivery/riders')
);

const partnerRoutes = () => (
	<>
		<Route
			path="/zones"
			element={
				<ProtectedRoute>
					<PartnerZonesPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/payments"
			element={
				<ProtectedRoute>
					<PartnerPaymentsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/account"
			element={
				<ProtectedRoute>
					<PartnerAccountPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/companies/create"
			element={
				<ProtectedRoute>
					<PartnerCompaniesFormPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/companies"
			element={
				<ProtectedRoute>
					<PartnerCompaniesPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/orders"
			element={
				<ProtectedRoute>
					<PartnerOrdersPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/reports"
			element={
				<ProtectedRoute>
					<PartnerReportsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/whatsapp"
			element={
				<ProtectedRoute>
					<WhatsappConfigPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/home"
			element={
				<ProtectedRoute>
					<PartnerHomePage />
				</ProtectedRoute>
			}
		/>
		{/* <Route
			path="/delivered"
			element={
				<ProtectedRoute>
					<DeliveryCompany />
				</ProtectedRoute>
			}
		/> */}
		<Route
			path="/expenses"
			exact
			element={
				<ProtectedRoute>
					<PartnerExpensesAndBasesPage typeEntity="expense" />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/bases"
			exact
			element={
				<ProtectedRoute>
					<PartnerExpensesAndBasesPage typeEntity="base" />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/schedules/:company"
			element={
				<ProtectedRoute>
					<SchedulesPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/product/:id/:company"
			element={
				<ProtectedRoute>
					<ProductPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/promo/:id/:company"
			element={
				<ProtectedRoute>
					<PromoPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/products-list/:company"
			element={
				<ProtectedRoute>
					<UploadProductsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/products-additions-list/:company"
			element={
				<ProtectedRoute>
					<UploadAdditionsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/products/:company"
			element={
				<ProtectedRoute>
					<ProductsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/company/:company"
			element={
				<ProtectedRoute>
					<BusinessPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/riders"
			element={
				<ProtectedRoute>
					<DeliveryRidersPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/riders-payments"
			element={
				<ProtectedRoute>
					<RiderPaymentsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/companies-payments"
			element={
				<ProtectedRoute>
					<CompaniesPaymentsPage />
				</ProtectedRoute>
			}
		/>
		<Route
			path="/requests"
			element={
				<ProtectedRoute>
					<RequestsNewCollaboratorsPage />
				</ProtectedRoute>
			}
		/>
	</>
);

export default partnerRoutes;
